import type { CrmContact } from '@tips-crm/shared';

export interface SellerContext {
  sellerId?: string;
  sellerName?: string;
  brandName?: string;
  sourceDomain?: string;
  sourcePhone?: string;
  channel?: string;
  direction?: string;
}

function contactName(c: CrmContact | null | undefined): string {
  if (!c) return 'Unknown contact';
  const parts = [c.first_name, c.last_name].filter(Boolean);
  return parts.length ? parts.join(' ') : c.email || c.phone_e164 || 'Unknown contact';
}

export function SellerContextCard({
  context,
  contact,
}: {
  context?: SellerContext;
  contact?: CrmContact | null;
}) {
  return (
    <div className="seller-card">
      <div className="seller-card__header">
        <h3>{contactName(contact)}</h3>
        {context?.channel && (
          <span className={`badge badge--${context.channel}`}>{context.channel}</span>
        )}
        {context?.direction && <span className="badge">{context.direction}</span>}
      </div>

      {contact && (
        <dl className="kv">
          {contact.company && (
            <>
              <dt>Company</dt>
              <dd>{contact.company}</dd>
            </>
          )}
          {contact.email && (
            <>
              <dt>Email</dt>
              <dd>{contact.email}</dd>
            </>
          )}
          {contact.phone_e164 && (
            <>
              <dt>Phone</dt>
              <dd>{contact.phone_e164}</dd>
            </>
          )}
          {contact.lifecycle_status && (
            <>
              <dt>Lifecycle</dt>
              <dd>{contact.lifecycle_status}</dd>
            </>
          )}
        </dl>
      )}

      <div className="seller-card__context">
        <h4>Seller context</h4>
        <dl className="kv">
          <dt>Seller</dt>
          <dd>{context?.sellerName || context?.sellerId || '—'}</dd>
          {context?.brandName && (
            <>
              <dt>Brand</dt>
              <dd>{context.brandName}</dd>
            </>
          )}
          {context?.sourceDomain && (
            <>
              <dt>Source domain</dt>
              <dd>{context.sourceDomain}</dd>
            </>
          )}
          {context?.sourcePhone && (
            <>
              <dt>Source number</dt>
              <dd>{context.sourcePhone}</dd>
            </>
          )}
        </dl>
      </div>
    </div>
  );
}
